module.exports = "/_next/static/images/9a8ea7c9ad46f0914da3b6b0eb4dce32-nubanker-eng@1x.jpg";